const ChipMap = {
    Layout: {
        id: '260167',
        name: 'Layout',
        type: 'struct',
        title: '通栏设置',
        groupName: '通栏设置',
    },
    NewsList: {
        id: '285750',
        name: 'NewsList',
        type: 'recommend',
        title: '新闻列表',
        groupName: '新闻列表'
    },
    Banner1: {
        id: '221365',
        name: 'Banner1',
        type: 'static',
        title: 'banner1',
        groupName: '新闻列表'
    },
    Swiper1: {
        id: '285751',
        name: 'Swiper1',
        type: 'recommend',
        title: '焦点图',
        groupName: '新闻列表'
    },
    Banner2: {
        id: '221366',
        name: 'Banner2',
        type: 'static',
        title: 'banner2',
        groupName: '新闻列表'
    },
    VideoList: {
        id: '285752',
        name: 'VideoList',
        type: 'recommend',
        title: '视频列表',
        groupName: '新闻列表'
    },
    Banner3: {
        id: '221367',
        name: 'Banner3',
        type: 'static',
        title: 'banner3',
        groupName: 'part1'
    },
    LargeVideo: {
        id: '285753',
        name: 'LargeVideo',
        type: 'recommend',
        title: '大视频',
        groupName: 'part1'
    },
    Banner4: {
        id: '221368',
        name: 'Banner4',
        type: 'static',
        title: 'banner4',
        groupName: 'part2'
    },
    FenghuangGuanCha: {
        id: '285754',
        name: 'FenghuangGuanCha',
        type: 'recommend',
        title: '凤凰观察',
        groupName: 'part2'
    },
    Banner5: {
        id: '221369',
        name: 'Banner5',
        type: 'static',
        title: 'banner5',
        groupName: 'part3'
    },
    DuDongZhongGuo: {
        id: '285755',
        name: 'DuDongZhongGuo',
        type: 'recommend',
        title: '读懂中国',
        groupName: 'part3'
    },
    Banner6: {
        id: '221370',
        name: 'Banner6',
        type: 'static',
        title: 'banner6',
        groupName: 'part4'
    },
    LiangHuiShaLong: {
        id: '285756',
        name: 'LiangHuiShaLong',
        type: 'recommend',
        title: '两会沙龙',
        groupName: 'part4'
    },
    Banner7: {
        id: '221371',
        name: 'Banner7',
        type: 'static',
        title: 'banner7',
        groupName: 'part5'
    },
    TuPianCeHua: {
        id: '260165',
        name: 'TuPianCeHua',
        type: 'struct',
        title: '图片策划',
        groupName: 'part5'
    },
    Banner8: {
        id: '221372',
        name: 'Banner8',
        type: 'static',
        title: 'banner8',
        groupName: 'part6'
    },
    GaoQingDaTu: {
        id: '285757',
        name: 'GaoQingDaTu',
        type: 'recommend',
        title: '高清大图',
        groupName: 'part6'
    },
    Banner9: {
        id: '221373',
        name: 'Banner9',
        type: 'static',
        title: 'banner9',
        groupName: 'part7'
    },
    Banner10: {
        id: '221374',
        name: 'Banner10',
        type: 'static',
        title: 'banner10',
        groupName: 'part7'
    },
    JiaBinGuanDian: {
        id: '285758',
        name: 'JiaBinGuanDian',
        type: 'recommend',
        title: '嘉宾观点',
        groupName: 'part7'
    },
    Banner11: {
        id: '221375',
        name: 'Banner11',
        type: 'static',
        title: 'banner11',
        groupName: 'part7'
    },
    XiangGuanBaoDao: {
        id: '285759',
        name: 'XiangGuanBaoDao',
        type: 'recommend',
        title: '相关报道',
        groupName: 'part7'
    },
    Support: {
        id: '260166',
        name: 'Support',
        type: 'struct',
        title: '赞助',
        groupName: 'part7'
    },
    Banner12: {
        id: '221440',
        name: 'Banner12',
        type: 'static',
        title: 'banner12',
        groupName: 'part8'
    },
    mainImage: {
        id: '221444',
        name: 'mainImage',
        type: 'static',
        title: '主图',
        groupName: 'mainImage'
    },
};

module.exports = { ChipMap };
